var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4686_159524)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    width: 5,
    height: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 20.2,
    height: 21,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2539 6.58829V6.91797H17.418V0H17.7437C18.0855 0 18.4113 0.135094 18.6517 0.37833L23.8801 5.67489C24.1204 5.91813 24.2539 6.24781 24.2539 6.58829Z",
    fill: "#CC9310"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.709 7.35031V0H5.02786C4.31752 0 3.74609 0.578287 3.74609 1.29715V26.3748C3.74609 27.0936 4.31752 27.6719 5.02786 27.6719H22.9722C23.6825 27.6719 24.254 27.0936 24.254 26.3747V8.64746H16.9907C16.2858 8.64746 15.709 8.06375 15.709 7.35031ZM19.127 20.1053C19.127 20.462 18.8386 20.7539 18.4861 20.7539H9.51393C9.16147 20.7539 8.87305 20.4621 8.87305 20.1053V19.673C8.87305 19.3163 9.16141 19.0244 9.51393 19.0244H18.4861C18.8385 19.0244 19.127 19.3162 19.127 19.673V20.1053ZM19.127 16.6463C19.127 17.003 18.8386 17.2949 18.4861 17.2949H9.51393C9.16147 17.2949 8.87305 17.0031 8.87305 16.6463V16.214C8.87305 15.8573 9.16141 15.5654 9.51393 15.5654H18.4861C18.8385 15.5654 19.127 15.8573 19.127 16.214V16.6463ZM19.127 12.755V13.1874C19.127 13.5441 18.8386 13.8359 18.4861 13.8359H9.51393C9.16147 13.8359 8.87305 13.5441 8.87305 13.1874V12.755C8.87305 12.3983 9.16141 12.1064 9.51393 12.1064H18.4861C18.8386 12.1064 19.127 12.3983 19.127 12.755Z",
    fill: "#ffbe00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4686_159524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileYellow);
export default __webpack_public_path__ + "static/media/file--yellow.0b9186b6de65dcec995c8bed54498d16.svg";
export { ForwardRef as ReactComponent };